import type { App } from "@upsquad/server";
import { baseApi } from "@/src/common/services/base-api";

type ApproveMemberResponse = App["~Routes"]["community"]["members"][":memberId"]["patch"]["response"]["200"];
type ApproveMemberBody = App["~Routes"]["community"]["members"][":memberId"]["patch"]["body"];

export type ApproveMemberAction = ApproveMemberBody["action"];

interface ApproveMemberParams {
	memberId: string;
	action: ApproveMemberAction;
}

const memberApprovalApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		approveMember: builder.mutation<ApproveMemberResponse, ApproveMemberParams>({
			query:
				({ memberId, action }) =>
				(client) =>
					client.community.members({ memberId }).patch({ action, member_id: memberId }),
			invalidatesTags: ["Members"],
		}),
	}),
});

export const { useApproveMemberMutation } = memberApprovalApi;
